import React, { memo } from 'react';

import { useTypedSelector } from '../../../../shared/hooks';
import ServiceIdentityFilter from '../ServiceIdentityFilter';
import ServiceIdentityList from '../ServiceIdentityList';
import { ServiceIdentityActionManager } from '../ServiceIdentityListAction';

import './ServiceIdentityTab.css';

/**
 * Renders the service identity tab with filters, list, and action manager.
 * @returns The ServiceIdentityTab component.
 */
function ServiceIdentityTab() {
  const { actionManager } = useTypedSelector(
    (state) => state.savicopilot.serviceIdentity
  );

  return (
    <div className='ServiceIdentityTab'>
      {/* Filters */}
      <ServiceIdentityFilter />
      {/* Lists */}
      <ServiceIdentityList />
      {/* Actions */}
      {actionManager?.isOpen && (
        <ServiceIdentityActionManager
          // eslint-disable-next-line react/jsx-props-no-spreading -- need to pass all the action properties
          {...actionManager}
        />
      )}
    </div>
  );
}

export default memo(ServiceIdentityTab);
